import type { AxiosRequestConfig } from 'axios';
import z from 'zod';
import { api } from '../../axios.instance';
import { responseContract } from '../../lib';
import { SparkLinePointDtoSchema } from '../contracts';

const _GetFacilityRevenueRequestDtoSchema = z.object({
  facilityId: z.number(),
  from: z.string().refine((val) => !isNaN(Date.parse(val)), 'Invalid datetime'),
  to: z.string().refine((val) => !isNaN(Date.parse(val)), 'Invalid datetime'),
  granularity: z.enum(['day', 'week', 'month']).optional(),
});

const GetFacilityRevenueResponseDtoSchema = z.object({
  revenue: z.object({
    amountUsd: z.number().nullable(),
    changePct: z.number().nullable(),
  }),
  sparkline: z.object({
    granularity: z.enum(['day', 'week', 'month']),
    points: z.array(SparkLinePointDtoSchema),
  }),
  payerDistribution: z.object({
    medicaid: z.object({
      currentPct: z.number(),
    }),
    private: z.object({
      currentPct: z.number(),
    }),
  }),
});

export type GetFacilityRevenueRequestDto = z.infer<
  typeof _GetFacilityRevenueRequestDtoSchema
>;
export type GetFacilityRevenueResponseDto = z.infer<
  typeof GetFacilityRevenueResponseDtoSchema
>;

export const getFacilityRevenue = (
  params: GetFacilityRevenueRequestDto,
  config?: AxiosRequestConfig<GetFacilityRevenueRequestDto>
) => {
  const { facilityId, ...restParams } = params;

  return api
    .get(`/facilities/${facilityId}/revenue`, {
      params: restParams,
      ...config,
    })
    .then(responseContract(GetFacilityRevenueResponseDtoSchema));
};
